<template>
  <img
    src="/zabbu_logo.png"
    alt="Zabbu Sign"
    style="width: 40px; height: 40px; object-fit: contain;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
